import { render, staticRenderFns } from "./ConfigGlobal.vue?vue&type=template&id=5395f092&scoped=true&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./ConfigGlobal.vue?vue&type=script&lang=js"
export * from "./ConfigGlobal.vue?vue&type=script&lang=js"
import style0 from "./ConfigGlobal.vue?vue&type=style&index=0&id=5395f092&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5395f092",
  null
  
)

export default component.exports